import Vue from "vue";



Vue.filter('TWD', currency => {
  if (isNaN(Number(currency))) {
    return currency;
  }
  currency = Math.round(currency);
  const array = [];
  let digits = String(currency).split('');
  while(digits.length) {
    array.unshift(digits.splice(-3).join(''));
  }
  return '$' + array.join(',');
});

